module.exports = __webpack_public_path__ + "img/proyecto_17.156749e6.webp";